import { getRootFolderForGivenContext } from './moveToCommonUtils';
import MoveToMailboxContext from '../store/schema/MoveToMailboxContext';
import { getEffectiveFolderDisplayName, getFolderTable } from 'owa-folders';
import { isStringNullOrWhiteSpace } from 'owa-localize';

export default function isFolderNameValid(
    moveToMailboxContext: MoveToMailboxContext,
    name: string
): boolean {
    // Valid folder name means the name string is not white space, or null, or empty
    // and it is not duplicated with existing folders in given mailbox
    return (
        !isStringNullOrWhiteSpace(name) && !isFolderNameDuplicate(moveToMailboxContext, name.trim())
    );
}

/**
 * Check whether the name of the folder being created has already a duplicate in given mailbox
 * @param name of the folder to be checked
 * @returns true if a folder does not have duplicate name with a folder in the root
 */
export function isFolderNameDuplicate(
    moveToMailboxContext: MoveToMailboxContext,
    name: string
): boolean {
    const childFolderIds = getRootFolderForGivenContext(moveToMailboxContext).childFolderIds;
    return childFolderIds.some(
        firstLevelFolderId =>
            getEffectiveFolderDisplayName(
                getFolderTable().get(firstLevelFolderId)
            ).toLocaleLowerCase() === name.toLocaleLowerCase()
    );
}
